import { toast } from "sonner";
import { Copy } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";

export const LEVEL_LABELS = {
  5: "iznimna razina",
  4: "vrlo dobra razina",
  3: "dobra razina",
  2: "zadovoljavajuća razina",
  1: "ishod još nije ostvaren",
};

const LEVEL_COLORS = {
  5: "bg-emerald-600",
  4: "bg-teal-600",
  3: "bg-blue-600",
  2: "bg-amber-500",
  1: "bg-rose-500",
};

const copy = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    toast.success("Bilješka je kopirana u međuspremnik.");
  } catch {
    toast.error("Kopiranje nije uspjelo. Pokušajte ručno.");
  }
};

const NoteCard = ({ note, onChange }) => (
  <div className="rounded-2xl border border-slate-200 bg-white p-4 md:p-5 shadow-sm space-y-3" data-testid={`note-card-${note.level}`}>
    <div className="flex items-center justify-between gap-3">
      <div className="flex items-center gap-2.5">
        <span className={`h-8 w-8 rounded-lg grid place-items-center text-white font-heading font-bold ${LEVEL_COLORS[note.level]}`}>
          {note.level}
        </span>
        <span className="text-sm font-medium text-slate-700">{LEVEL_LABELS[note.level]}</span>
      </div>
      <Button
        size="sm"
        onClick={() => copy(note.text)}
        disabled={!note.text}
        data-testid={`note-copy-${note.level}`}
        className="bg-slate-900 hover:bg-slate-800 text-white rounded-lg"
      >
        <Copy className="h-3.5 w-3.5 mr-1.5" />
        Kopiraj
      </Button>
    </div>
    <Textarea
      value={note.text}
      onChange={(e) => onChange(e.target.value)}
      data-testid={`note-text-${note.level}`}
      className="min-h-[110px] rounded-xl border-slate-200 text-sm leading-relaxed"
    />
  </div>
);

export const FormativeNotes = ({ notes, onChange }) => (
  <div className="space-y-3" data-testid="formative-notes">
    {notes.map((n) => (
      <NoteCard key={n.level} note={n} onChange={(text) => onChange(n.level, text)} />
    ))}
  </div>
);

export default FormativeNotes;
